(function($) {
    'use strict';

    var cookiePrompt = window.cookiePrompt;
    if (cookiePrompt == null) {
        return;
    }

    cookiePrompt.options.privacyLink = '/policy#fancy-title-27';

}(jQuery));
